import axios from "axios";
import { authHeader, isTokenExpired } from "../helpers";

export const myExpariencesService = {
  fetchMyExpariences,
  fetchUserExpariences,
  fetchSingleExparience,
  fetchUnloggedSingleUserExparience,
  isExparienceNameExist,
  createNewExparience,
  updateExparienceByRole,
  updateConfigurator,
  updateExparience,
  updateExpariencePaintings,
  deleteExparience,
  // fetchUsers,
  sendNotification,
  updateVisible,
  loadTargets,
  updatePublication,
  duplicateExparience,
  saveExternalLinks,
  saveExparienceExternalLinks,
  getOfferings,
  getSurvey,
  getSurveysAnswers,
  saveExparienceSurvey,
  deleteSurvey,
  fetchExparienceStats,
  translateSurvey,
  translateDescription,
  translateMultipleLanguages,
  getModelUrlFromS3,
  getImageUrlFromS3,
  updateHdrImage,
  uploadAmbiantMusic,
  changeAmbiantMusicStatus,
  uploadConfiguratorThemes,
  uploadVideosForScreen,
  updateFrameVisibility,
  getGlobeStats,
  unsubscribeGlobe,
  updateStatWebview,
  uploadPromotedLogo,
  deletePromotedLogo,
  getPromotedLogos,
  promoteExparience,
  unPromoteExparience,
  updateAppearanceConfig,
  getAllHdr,
  addHdr,
  deleteHdr,
  updateAvatarisation,
  updateWebArActions,
  uploadPromotedVideo,
  deletePromotedVideo,
  getPromotedVideos,
  filterStats,
  saveWebXrOrder,
  fetchGameTypes,
  fetchUnityFinalJson,
  getLeaderboardsForStats,
  getStandaloneLeaderboard,
  searchDmaExparience,
  getExpariencesWithGames,
  addLeaderboardScore,
  deleteLeaderboardScore,
  sendPurchasedGeoloc,
  getLeaderboardExport,
  getUserPurchasableGeolocs,
  getUserPurchasedGeolocs,
  fetchPurchasedGeolocsSingleExparience,
  getClassImageUrlFromS3,
};

function fetchMyExpariences(offset = "default", limit = "default") {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (offset === "default" && limit === "default") {
    return fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/admin/dm?offset=0&limit=99999`,
      requestOptions
    )
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  } else {
    return fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/admin/dm?offset=${offset}&limit=${limit}`,
      requestOptions
    )
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  }
}

function fetchUserExpariences(offset = "default", limit = "default") {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  if (offset === "default" && limit === "default") {
    return fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/dm/me?offset=0&limit=99999`,
      requestOptions
    )
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status < 300) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  } else {
    return fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/dm/me?offset=${offset}&limit=${limit}`,
      requestOptions
    )
      .then((res) => isTokenExpired(res))
      .then((res) => {
        if (res.status < 300) {
          return res.json();
        } else {
          const error = (res && res.message) || res.statusText;
          return Promise.reject(error);
        }
      });
  }
}

function fetchSingleExparience(id, isAdmin) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${id}/full`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/full`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchPurchasedGeolocsSingleExparience(id, isAdmin) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${id}/purchase-geoloc`
    : `${process.env.REACT_APP_GATEWAY_URL}/public/dm/${id}/purchase-geoloc`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchUnloggedSingleUserExparience(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/public/dm/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchUnityFinalJson(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/full/appv2`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function isExparienceNameExist(name) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${name}/exists`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.json().then((res) => {
    if (response.status === 200) {
      return res;
    } else {
      const error = (res && res.message) || response.statusText;
      return Promise.reject(error);
    }
  });
}

function createNewExparience(digitmuz, files) {
  const formData = new FormData();
  formData.append("digitmuz", JSON.stringify(digitmuz));
  for (const file of files) {
    formData.append("images", file, file.name);
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + "/admin/dm/";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve(res.json());
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

///// exparience v2 APIs

function updateExparienceByRole(digitmuz, files, isAdmin) {
  const formData = new FormData();
  formData.append("digitmuz", JSON.stringify(digitmuz));
  for (const file of files) {
    formData.append("images", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const roleRoute = isAdmin ? "/admin/dm/" : `/dm/${digitmuz._id}`;
  const url = process.env.REACT_APP_GATEWAY_URL + roleRoute;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateConfigurator(configurator, files, id, isAdmin) {
  const formData = new FormData();
  formData.append("config", JSON.stringify(configurator));
  for (const file of files) {
    formData.append("images", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const roleRoute = isAdmin ? `/admin/dm/${id}/config` : `/dm/${id}/config`;
  const url = process.env.REACT_APP_GATEWAY_URL + roleRoute;
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

/////

function updateExparience(digitmuz, files) {
  const formData = new FormData();
  formData.append("digitmuz", JSON.stringify(digitmuz));
  for (const file of files) {
    formData.append("images", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + "/admin/dm/";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateExpariencePaintings(digitmuz, files) {
  const formData = new FormData();
  formData.append("digitmuz", JSON.stringify(digitmuz));
  for (const file of files) {
    formData.append("images", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + `/dm/${digitmuz._id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteExparience(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

// export function fetchUsers() {
//   const requestOptions = {
//     method: "GET",
//     headers: authHeader(),
//   };
//   return fetch(
//     process.env.REACT_APP_API_URL + "/accounts/users",
//     requestOptions
//   )
//     .then((res) => isTokenExpired(res))
//     .then((res) => {
//       if (res.status < 300) {
//         return res.json();
//       } else {
//         const error = (res && res.message) || res.statusText;
//         return Promise.reject(error);
//       }
//     });
// }

function sendNotification(id, isAdmin) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  const roleRoute = isAdmin ? `/admin/dm/notify/${id}` : `/dm/notify/${id}`;
  const url = process.env.REACT_APP_GATEWAY_URL + roleRoute;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateVisible(id, isAdmin, visible) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };
  let roleRoute;
  if (!visible) {
    roleRoute = isAdmin ? `/admin/dm/invisible/${id}` : `/dm/invisible/${id}`;
  } else {
    roleRoute = isAdmin ? `/admin/dm/visible/${id}` : `/dm/visible/${id}`;
  }

  const url = process.env.REACT_APP_GATEWAY_URL + roleRoute;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function loadTargets(value) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    process.env.REACT_APP_API_URL + "/search/targets?search=" + value,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updatePublication(id, value, isAdmin) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  let url;
  if (!isAdmin)
    url = value
      ? `${process.env.REACT_APP_GATEWAY_URL}/dm/publish/${id}`
      : `${process.env.REACT_APP_GATEWAY_URL}/dm/unpublish/${id}`;
  else
    url = value
      ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/publish/${id}`
      : `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/unpublish/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export function duplicateExparience(id, toastSuccess, toastError) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };
  return fetch(
    process.env.REACT_APP_GATEWAY_URL + "/admin/dm/" + id + "/duplicate",
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        toastSuccess();
        return res.json();
      } else {
        toastError();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export async function saveExternalLinks(id, externalLinks, logos) {
  const formData = new FormData();
  formData.append("externalLinks", JSON.stringify(externalLinks));
  for (const logo of logos) {
    const res = await fetch(logo.file);
    const newBlob = await res.blob();
    formData.append("logos", newBlob, logo.fileName);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_GATEWAY_URL + "/dm/" + id + "/external-links";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve(res.json());
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export async function saveExparienceExternalLinks(
  id,
  configId,
  externalLinks,
  logos
) {
  const formData = new FormData();
  formData.append("externalLinks", JSON.stringify(externalLinks));
  for (const logo of logos) {
    const res = await fetch(logo.file);
    const newBlob = await res.blob();
    formData.append("logos", newBlob, logo.fileName);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_GATEWAY_URL +
    "/dm/" +
    id +
    "/config/" +
    configId +
    "/external-links";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve(res.json());
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getOfferings() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/payments/offerings`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchExparienceStats(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/statistics/expariences/${id}/all`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateStatWebview(statistics) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    body: JSON.stringify(statistics),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/public/dm/webview/statistics`,
    requestOptions
  ).then((res) => {
    if (res.status < 300) {
      return Promise.resolve();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function getSurvey(configId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/surveys/config/${configId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getSurveysAnswers(configId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/surveys/${configId}/answers/statistics`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

export async function saveExparienceSurvey(survey, images) {
  const formData = new FormData();
  formData.append("survey", JSON.stringify(survey));
  for (const image of images) {
    if (image.hasOwnProperty("mainLogo")) {
      formData.append("images", image.file, image.fileName);
    } else {
      const res = await fetch(image.file);
      const newBlob = await res.blob();
      formData.append("images", newBlob, image.fileName);
    }
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + "/surveys";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve(res.json());
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteSurvey(surveyId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/surveys/${surveyId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function translateSurvey(body, lang) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(body),
  };

  const url =
    process.env.REACT_APP_GATEWAY_URL + "/surveys/translate?lang=" + lang;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getModelUrlFromS3(exparienceId, files, isAdmin) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("object", file, file.name.replaceAll(" ", ""));
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = isAdmin
    ? process.env.REACT_APP_GATEWAY_URL +
      "/admin/dm/" +
      exparienceId +
      "/upload-gltf"
    : process.env.REACT_APP_GATEWAY_URL +
      "/dm/" +
      exparienceId +
      "/upload-gltf";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

async function getImageUrlFromS3(
  isAdmin,
  exparienceId,
  file,
  needBlob = false,
  blobName
) {
  const formData = new FormData();
  if (needBlob) {
    const res = await fetch(file);
    const newBlob = await res.blob();
    formData.append("image", newBlob, blobName);
  } else formData.append("image", file, file.name);

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/upload-image`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/upload-image`;

  return fetch(url, requestOptions)
    .then((res) => {
      return isTokenExpired(res);
    })
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function translateDescription(text, lang) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ text }),
  };

  const url = process.env.REACT_APP_GATEWAY_URL + "/dm/translate/" + lang;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function translateMultipleLanguages(text, langArray) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ text, languages: langArray }),
  };

  const url =
    process.env.REACT_APP_GATEWAY_URL + "/dm/translate-multiple/langs";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateHdrImage(files, exparienceId) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("image", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url =
    process.env.REACT_APP_GATEWAY_URL + "/dm/" + exparienceId + "/upload-hdr";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadAmbiantMusic(files, exparienceId, isAdmin) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("audio", file, file.name);
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/ambiant-music/upload`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/ambiant-music/upload`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function changeAmbiantMusicStatus(exparienceId, isAdmin, nextStatus) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  let url;
  if (!isAdmin)
    url = nextStatus
      ? `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/ambiant-music/activate`
      : `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/ambiant-music/deactivate`;
  else
    url = nextStatus
      ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/ambiant-music/activate`
      : `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/ambiant-music/deactivate`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadConfiguratorThemes(themes, files, exparienceId, isAdmin) {
  const formData = new FormData();
  formData.append("themes", JSON.stringify(themes));
  for (const file of files) {
    formData.append("audios", file, file.name.replaceAll(" ", "-"));
  }

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = isAdmin
    ? process.env.REACT_APP_GATEWAY_URL +
      "/admin/dm/" +
      exparienceId +
      "/themes"
    : process.env.REACT_APP_GATEWAY_URL + "/dm/" + exparienceId + "/themes";

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadVideosForScreen(
  exparienceId,
  file,
  handleProgress,
  index,
  isAdmin
) {
  let formData = new FormData();
  formData.append("video", file);

  const config = {
    headers: authHeader(true),
    onUploadProgress: (progressEvent) => {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      handleProgress(index, percentCompleted);
    },
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/video`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/video`;

  return axios.post(url, formData, config);
}

function updateFrameVisibility(id, configId, visibility, isAdmin) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  let roleRoute;
  if (visibility) {
    roleRoute = isAdmin
      ? `/admin/dm/${id}/config/${configId}/invisible`
      : `/dm/${id}/config/${configId}/invisible`;
  } else {
    roleRoute = isAdmin
      ? `/admin/dm/${id}/config/${configId}/visible`
      : `/dm/${id}/config/${configId}/visible`;
  }

  const url = process.env.REACT_APP_GATEWAY_URL + roleRoute;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getGlobeStats() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/statistics?type=launch`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function unsubscribeGlobe(route) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(route, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadPromotedLogo(exparienceId, file) {
  const formData = new FormData();
  formData.append("logo", file);

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/promoted-logo`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function getPromotedLogos(offset, limit) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/promoted-logo?offset=${offset}&limit=${limit}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function getExpariencesWithGames(offset, limit) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/games?offset=${offset}&limit=${limit}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function deletePromotedLogo(exparienceId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/promoted-logo`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function getPromotedVideos(offset, limit) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/promoted-video?offset=${offset}&limit=${limit}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadPromotedVideo(exparienceId, file) {
  const formData = new FormData();
  formData.append("video", file);

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/promoted-video`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function deletePromotedVideo(exparienceId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(true),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/promoted-video`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function promoteExparience(exparienceId, toastSuccess, toastError) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/promote`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        toastSuccess();
        return res.json();
      } else {
        let tmp = await res.json();
        toastError();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function unPromoteExparience(exparienceId, toastSuccess, toastError) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/un-promote`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        toastSuccess();
        return res.json();
      } else {
        let tmp = await res.json();
        toastError();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function updateAppearanceConfig(exparienceId, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/appearance/${value}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function getAllHdr() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/hdr`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function addHdr(img, name) {
  const toSend = new FormData();
  toSend.append("image", img, img.name);
  toSend.append("name", name);

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: toSend,
  };

  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/admin/hdr`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteHdr(hdrId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/hdr/${hdrId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function updateAvatarisation(exparienceId, isAdmin) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${exparienceId}/avatar`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${exparienceId}/avatar`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function updateWebArActions(id, configId, webArActionLink, isAdmin) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({
      webArAction: webArActionLink,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/${
      isAdmin ? "admin/" : ""
    }dm/${id}/config/${configId}/webArAction`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function filterStats(data, Id) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/statistics/expariences/${Id}/filter`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function saveWebXrOrder(webXrOrder, id, isAdmin) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ webXrOrder }),
  };

  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/${id}/webXrOrder`
    : `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/webXrOrder`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchGameTypes(type, category) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/games/${type}/${category}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getLeaderboardsForStats(
  exparienceId,
  gameKind,
  gameLevel,
  gameCategory
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/games/${exparienceId}?kind=${gameKind}&level=${gameLevel}&category=${gameCategory}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getStandaloneLeaderboard(
  exparienceId,
  gameKind,
  gameLevel,
  gameCategory
) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/public/games/${exparienceId}?kind=${gameKind}&level=${gameLevel}&category=${gameCategory}`;

  return fetch(url, requestOptions).then((res) => {
    if (res.status < 300) {
      return res.json();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function searchDmaExparience(
  name,
  promotedLogo = false,
  promotedVideo = false
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/search/${name}?promotedLogo=${promotedLogo}&promotedVideo=${promotedVideo}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addLeaderboardScore(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/games`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json(); // replace the map wuth exparienceGame
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteLeaderboardScore(scoreId, exparienceId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/games/${scoreId}/exparience/${exparienceId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

async function sendPurchasedGeoloc(id, dataArray) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/purchase-geoloc`,
      {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(dataArray),
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    const result = await response.json();
    window.location.href = result["url"];
  } catch (error) {
    console.error("Erreur lors de l'envoi de la requête :", error);
    throw error;
  }
}

function getLeaderboardExport() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/games`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getUserPurchasableGeolocs(offset, limit) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/dm/purchasable-geolocs?offset=${offset}&limit=${limit}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getUserPurchasedGeolocs() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/dm/me/purchased-geolocs`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

async function getClassImageUrlFromS3(file, needBlob = false, blobName) {
  const formData = new FormData();
  if (needBlob) {
    const res = await fetch(file);
    const newBlob = await res.blob();
    formData.append("image", newBlob, blobName);
  } else formData.append("image", file, file.name);

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/dm/groups/upload-image`,
    requestOptions
  )
    .then((res) => {
      return isTokenExpired(res);
    })
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
